import React from 'react';
import { APP_ACCENT } from '@/constant/theme/colors.constant';

export type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg';
export type SpinnerColor =
  | 'primary'
  | 'secondary'
  | 'white'
  | 'gray'
  | 'indigo'
  | 'emerald'
  | 'red'
  | 'amber'
  | 'current';

export interface SpinnerProps {
  size?: SpinnerSize;
  color?: SpinnerColor;
  className?: string;
}

const sizeMap: Record<SpinnerSize, string> = {
  xs: 'h-3.5 w-3.5',
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
};

const colorMap: Record<SpinnerColor, string> = {
  primary: 'text-[var(--color-primary)]',
  secondary: 'text-[var(--color-secondary)]',
  white: 'text-white',
  gray: APP_ACCENT.gray.text,
  indigo: APP_ACCENT.indigo.text,
  emerald: APP_ACCENT.emerald.text,
  red: APP_ACCENT.red.text,
  amber: APP_ACCENT.amber.text,
  current: '', // inherits currentColor from parent
};

/**
 * Lightweight inline spinner atom.
 *
 * @example
 * <Spinner size="xs" color="indigo" />
 * <Spinner size="md" color="primary" />
 */
const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  color = 'primary',
  className = '',
}) => (
  <svg
    className={['animate-spin', sizeMap[size], colorMap[color], className]
      .filter(Boolean)
      .join(' ')}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    />
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
  </svg>
);

export default Spinner;
